module.exports = __webpack_public_path__ + "img/foot_icon1.e014f627.png";